<template>
  <v-dialog v-model="dialog" :max-width="options.width" :persistent="options.persistent" @keydown.esc="cancel()">

    <v-card tile>
      <v-card-text v-show="!!message">{{ message }}</v-card-text>


    <v-list two-line>

          <template v-for="(item, index) in items">
            <v-list-item
              :key="item.id"
              ripple
              @click="select(item)"
            >
              <v-list-item-avatar>
                <span class="primary--text">{{ item.type }}</span>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="subtitle-2">{{ item.client_lastname + ' ' + item.client_firstname }} </v-list-item-title>
                <v-list-item-subtitle>{{ item.ap_date | date}} {{ item.ap_time | formatTime}}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-icon>
                <v-icon :color="item.active ? 'deep-purple accent-4' : 'grey'">edit</v-icon>
              </v-list-item-icon>
            </v-list-item>

          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </template>

    </v-list>

    </v-card>
  </v-dialog>
</template>

<script>
  /**
   * Vuetify Confirm Dialog component
   *
   * Insert component where you want to use it:
   * <confirm ref="confirm"></confirm>
   *
   * Call it:
   * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {});
   *
   * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
   * <template>
   *   <v-app>
   *     ...
   *     <confirm ref="confirm"></confirm>
   *   </v-app>
   * </template>
   *
   * mounted() {
   *   this.$root.$confirm = this.$refs.confirm.open;
   * }
   */
  export default {
    data () {
      return {
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        items: [],
        selected: null,
        list: null,
        options: {
          persistent: false,
          color: 'primary',
          width: 400
        }
      };
    },
    methods: {
      open (list, message, options) {
        this.dialog = true;
        this.items = list;
        this.selected = list[0];
        this.message = message;
        this.options = Object.assign(this.options, options);
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      },
      select (item) {
        this.selected = item;
        this.resolve(this.selected);
        this.dialog = false;
      },
      agree () {
        this.resolve(this.selected);
        this.dialog = false;
      },
      cancel () {
        this.resolve(false);
        this.dialog = false;
      }
    }
  }
</script>
